import { AVATAR_DEFAULT_SRC } from '@lean-body/components/atoms/avatar_uploader';
// NPC固定画像（user_profile/sabo.png）は assets CDN、実ユーザーは users CDN
const buildProfilePictureUrl = (path, config) => {
    const normalizedPath = path.replace(/^\//, '');
    const baseURL = normalizedPath.startsWith('user_profile/') ? config.cdnBaseURL : config.cdnUserBaseURL;
    return `${baseURL}/${normalizedPath}`;
};
export class LeagueLeaderboardUser {
    constructor(data, config) {
        Object.defineProperty(this, "rank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "profilePictureSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "score", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isMe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.rank = data.rank;
        this.userId = data.userId;
        this.userName = data.userName;
        this.profilePictureSrc = data.profilePictureSrc ? buildProfilePictureUrl(data.profilePictureSrc, config) : null;
        this.score = data.score;
        this.isMe = data.isMe;
    }
    get pictureSrc() {
        var _a;
        return (_a = this.profilePictureSrc) !== null && _a !== void 0 ? _a : AVATAR_DEFAULT_SRC;
    }
    // 名前が空のユーザーは「ゲスト」として表示する
    get displayName() {
        return this.userName || 'ゲスト';
    }
    // score は秒で保持しているため表示用に分へ変換する（切り捨て）
    get scoreMinutes() {
        return Math.floor(this.score / 60);
    }
}
export class LeagueMeta {
    constructor(data, config) {
        Object.defineProperty(this, "leagueTierName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "leagueTiersHeaderSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promotionTiersHeaderSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "tier", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "iconSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.leagueTierName = data.leagueTierName;
        this.leagueTiersHeaderSrc = data.leagueTiersHeaderSrc ? config.cdnBaseURL + data.leagueTiersHeaderSrc : '';
        this.promotionTiersHeaderSrc = data.promotionTiersHeaderSrc ? config.cdnBaseURL + data.promotionTiersHeaderSrc : '';
        this.tier = data.tier;
        this.iconSrc = data.iconSrc ? config.cdnBaseURL + data.iconSrc : '';
    }
}
export class LeagueLeaderboard {
    constructor(data, config) {
        Object.defineProperty(this, "isParticipating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isTotaling", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showDailyStartLead", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "league", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "daysRemaining", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "promotionZone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maintenanceZone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "demotionZone", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isParticipating = data.isParticipating;
        this.isTotaling = data.isTotaling;
        this.showDailyStartLead = data.showDailyStartLead;
        this.league = data.league ? new LeagueMeta(data.league, config) : null;
        this.daysRemaining = data.daysRemaining;
        this.promotionZone = (data.promotionZone || []).map((v) => new LeagueLeaderboardUser(v, config));
        this.maintenanceZone = (data.maintenanceZone || []).map((v) => new LeagueLeaderboardUser(v, config));
        this.demotionZone = (data.demotionZone || []).map((v) => new LeagueLeaderboardUser(v, config));
    }
}
